import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHead: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="head, avatar"><path d="M18.25 18.1667H14.25V21.25H6.75C6.75 18.6556 6.97969 16.5372 5.28425 14.3811C4.3231 13.1588 3.75 11.6184 3.75 9.94444C3.75 5.97106 6.97898 2.75 10.9621 2.75C13.8984 2.75 16.6018 4.15584 17.7163 6.99759C18.4972 8.98885 19.553 10.4589 20.75 12.25L18.25 13.5417V18.1667Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconHead;
